import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ResetMember = Loadable(
  lazy(() => import("features/resetMember/components/ResetMember"))
);

const routes = {
  path: "resetMember",
  children: [{ path: "", element: <ResetMember /> }],
};

export default routes;
